/* Alpha Elements – FAQ (/pages/faq): Suche, Themen-Navigation (Zähler + Scrollspy) und Deep-Links auf einzelne Fragen (#q-…).
   Markup: sections/ae-faq-hero.liquid (Suchfeld #faq-search) + sections/ae-faq-main.liquid ([data-faq]). Vanilla, ohne Abhängigkeiten. */
(() => {
  'use strict';
  const fold = s => s.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
  const plain = s => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss');
  const hashId = h => { try { return decodeURIComponent((h || '').slice(1)); } catch (e) { return ''; } };
  let state = null, io = null;

  function init() {
    const root = document.querySelector('[data-faq]');
    if (!root) { state = null; return; }
    const input = document.getElementById('faq-search');
    const status = document.getElementById('faq-status');
    const groups = [...root.querySelectorAll('.faq-group')];
    const items = [...root.querySelectorAll('.faq-group details')];
    const navLinks = [...root.querySelectorAll('.faq-nav a')];
    state = {
      root, input, status, groups, items, navLinks,
      empty: document.getElementById('faq-empty'),
      defaultStatus: status ? status.textContent : '',
      index: items.map(d => { const t = d.textContent + ' ' + (d.dataset.k || ''); return fold(t) + ' ' + plain(t); }),
      autoOpened: [], timer: 0,
    };
    if (input && !input.dataset.faqBound) {
      input.dataset.faqBound = '1';
      input.addEventListener('input', () => { if (!state) return; clearTimeout(state.timer); state.timer = setTimeout(filter, 150); });
      input.addEventListener('keydown', e => { if (e.key === 'Enter' && state) { e.preventDefault(); clearTimeout(state.timer); filter(); } });
      if (input.value) filter();
    }
    /* Scrollspy für die Themen-Navigation */
    io?.disconnect();
    if ('IntersectionObserver' in window && navLinks.length) {
      io = new IntersectionObserver(entries => entries.forEach(e => {
        if (!e.isIntersecting) return;
        navLinks.forEach(a => { if (a.hash === '#' + e.target.id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      }), { rootMargin: '-30% 0px -65% 0px' });
      groups.forEach(g => io.observe(g));
    }
    openTarget(hashId(location.hash));
  }

  function filter() {
    const s = state; if (!s || !s.input) return;
    const raw = s.input.value.trim();
    const terms = raw ? raw.split(/\s+/).map(t => [fold(t), plain(t)]) : [];
    s.autoOpened.forEach(d => { d.open = false; });
    s.autoOpened = [];
    let hits = 0;
    s.items.forEach((d, i) => {
      const ok = terms.every(([a, b]) => s.index[i].includes(a) || s.index[i].includes(b));
      d.hidden = !ok;
      if (ok) hits++;
    });
    s.groups.forEach(g => {
      const n = g.querySelectorAll('details:not([hidden])').length;
      g.hidden = n === 0;
      const link = s.navLinks.find(a => a.hash === '#' + g.id);
      if (link) { const c = link.querySelector('.faq-nav__count'); if (c) c.textContent = n; link.classList.toggle('is-empty', n === 0); }
    });
    if (raw && hits > 0 && hits <= 3) s.items.forEach(d => { if (!d.hidden && !d.open) { d.open = true; s.autoOpened.push(d); } });
    if (s.empty) s.empty.hidden = !(raw && hits === 0);
    if (s.status) s.status.textContent = !raw ? s.defaultStatus
      : hits === 0 ? `Keine passende Antwort für „${raw}“.`
      : `${hits === 1 ? '1 passende Antwort' : hits + ' passende Antworten'} für „${raw}“.`;
  }

  /* Deep-Links: Frage öffnen (auch wenn die Suche sie gerade ausblendet) */
  function openTarget(id) {
    const s = state;
    const el = id && document.getElementById(id);
    if (!s || !el || !s.root.contains(el)) return;
    if (s.input && s.input.value) { s.input.value = ''; filter(); }
    if (el.tagName === 'DETAILS') el.open = true;
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (a) openTarget(hashId(a.hash));
  });
  addEventListener('hashchange', () => openTarget(hashId(location.hash)));

  /* Theme-Editor: Section neu geladen bzw. Frage-Block ausgewählt */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', e => { const d = e.target.closest?.('details'); if (d) d.open = true; });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
